import useServicesTable from '@/hooks/table/useServicesTable';
import type React from 'react';
import ErrorMessage from '../../error-message/ErrorMessage';
import BlockServiceReducerContainer from '../../modals/block-service-reducer/BlockServiceReducer';
import { GenericTable } from '../common/generic-table/GenericTable';
import TableToolBar from './TableToolBar';

const ServicesTable: React.FC = () => {
  const {
    table,
    emptyData,
    state,
    filtering,
    setFiltering,
    dispatch,
    isFetching,
    isLoading,
    isError
  } = useServicesTable();

  if (isError) {
    return <ErrorMessage />;
  }
  return (
    <>
      <BlockServiceReducerContainer state={state} dispatch={dispatch} />
      <TableToolBar
        table={table}
        isFetching={isFetching}
        disabled={emptyData}
        filtering={filtering}
        setFiltering={setFiltering}
      />
      <GenericTable table={table} isLoading={isLoading} />
    </>
  );
};

export default ServicesTable;
